import {
  SendGroupSmsReq,
  SendGroupSmsResp,
  SendGroupSmsInterface,
} from "../GroupSms/GroupSms.model";
import { utilService } from "../../../services/utilService";
import { apiServiceConstants } from "../../../constants/apiService.constants";
import { apiService } from "../../../services/apiService";

const sendGroupSms = async (
  params: SendGroupSmsReq
): Promise<SendGroupSmsResp> => {
  const respApiResult = await apiService
    .apiCall(
      `user/group-sms/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const sendGroupSmsResp = res as SendGroupSmsResp;

      const result: SendGroupSmsInterface = {
        isSuccess: true,
        status: sendGroupSmsResp.status,
        message: sendGroupSmsResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: SendGroupSmsInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const handleErrorResponse = () => {};

export const groupSmsService = {
  sendGroupSms,
  handleErrorResponse,
};
